<div>
  <a *ngIf="showSelfPublishBanner" [href]="selfPublishHref" target="_blank" rel="noopener">
    <img [src]="selfPublishImgSrc">
  </a>

  <a *ngIf="showTwentyFourSymbolsBanner" [href]="twentyFourSymbolsHref" target="_blank" rel="noopener" (click)="handleTwentyFourClick($event)">
    <img [src]="twentyFourSymbolsImgSrc">
  </a>

  <a *ngIf="showRemoteLoginBanner" [href]="remoteLoginHref" target="_blank" rel="noopener">
    <img class="remote-login-image" [src]="remoteLoginImgSrc" defaultCover="assets/otk-remote-login.svg" [alt]="remoteLoginImgAlt">
  </a>
</div>
